import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import 'rxjs';

@Injectable()
export class GetDataService {
  private headers: HttpHeaders;
  private _UserUrl = window.location.origin + '/ftportal/uaa/api/users';
  private _getAdminApi = window.location.origin + '/ftportal/user-info';
  private _getDropDownPartnerList = window.location.origin + '/ftportal/ui/partners';

  constructor(private _http: HttpClient) {
  }

  createUser(userBody: any): any {
    return this._http.post(this._UserUrl, userBody);
  }

  getUser(pageSize: string): any {
    let params = new HttpParams();
    params = params.append('page', pageSize)
      .append('size', '10');
    return this._http.get(this._UserUrl, {params: params, observe: 'response'});
  }

  updateUser(userBody: any): any {
    return this._http.put(this._UserUrl, userBody);
  }

  getAdminInfo(): any {
    const params = new HttpParams();
    return this._http.get(this._getAdminApi, {params: params});
  }

  getDropDownPartners(): any {
    this.headers = new HttpHeaders()
      .append('External-Application', 'anything')
      .append('User-Id', 'aa');
    return this._http.get(this._getDropDownPartnerList, {headers: this.headers});
  }
}
